import React, { useCallback, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import IconComponent from "../../components/common/IconComponent";

const EventSpaceSpecialtiesArray = (
  fieldArrayRenderProps: FieldArrayRenderProps,
) => {
  const dispatch = useAppDispatch();
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("deleteeventspacespeciality"));
    setDeleteIndex(index);
  };

  const handleDeleteAction = useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      setDeleteIndex(-1);
    },
    [fieldArrayRenderProps],
  );

  const pushElementInarray = useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        EventSpaceSpecialties: "",
      },
    });
  }, [fieldArrayRenderProps]);

  if (!fieldArrayRenderProps?.value?.length) {
    pushElementInarray();
  }

  return (
    <>
      <GridLayoutItem
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <Typography.h5 className="m-0">Specialties</Typography.h5>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
          size="small"
        >
          + Add
        </Button>
      </GridLayoutItem>

      {dialogName === "deleteeventspacespeciality" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Speciality"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this speciality?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: 10,
                }}
              >
                <DialogCloseButton themeColor="dark" fillMode="flat" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(deleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}

      <GridLayoutItem>
        <GridLayout
          style={{ marginRight: 80 }}
          gap={{ rows: 5, cols: 25 }}
          cols={[
            { width: "25%" },
            { width: "25%" },
            { width: "25%" },
            { width: "25%" },
          ]}
        >
          {fieldArrayRenderProps.value &&
            fieldArrayRenderProps.value.length > 0 &&
            fieldArrayRenderProps.value?.map((_: any, index: number) => (
              <GridLayoutItem
                key={index}
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <Field
                    name={`EventSpaceSpecialties.${index}.EventSpaceSpecialties`}
                    placeholder="Enter Title"
                    component={FormTextField}
                    validator={requiredValidator}
                    showErrorMessage={false}
                  />
                </div>
                <div>
                  <Button
                    type="button"
                    themeColor={"error"}
                    fillMode={"solid"}
                    style={{
                      position: "relative",
                      padding: "5px 10px",
                      width: 30,
                      height: 30,
                      color: "#fff",
                      zIndex: "1",
                      borderRadius: "5px",
                      marginTop: 15,
                    }}
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps?.value?.length === 1}
                  >
                    <IconComponent
                      icon={MdDelete}
                      className="absolute-position fs-5"
                    />
                  </Button>
                </div>
              </GridLayoutItem>
            ))}
        </GridLayout>
      </GridLayoutItem>
    </>
  );
};

export default EventSpaceSpecialtiesArray;
